/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { Text } from 'framework/components/ui';

export const renderLabel = (Label: React.ReactNode) => (typeof Label === 'function' ? <Label />
  : (typeof Label === 'string' ? <Text caption={Label} /> : <>{Label}</>));
